// ============================================================================
// CrewAhead Maritime Platform - Hooks Barrel Export
// ============================================================================

// Auth hook
export { useAuth } from './useAuth';
export type { UseAuthReturn } from './useAuth';

// Profile hook
export { useProfile } from './useProfile';
export type { UseProfileReturn } from './useProfile';

// Generic API hook
export {
  useApi,
  useApiQuery,
  useApiMutation,
  useGet,
  usePost,
  usePut,
  usePatch,
  useDelete,
} from './useApi';
export type { UseApiReturn } from './useApi';

// Form hook
export {
  useForm,
  useCreateForm,
  useEditForm,
  useFormWithApiErrors,
  useUnsavedChangesWarning,
} from './useForm';
export type { UseFormOptions, UseFormHookReturn } from './useForm';

// Jobs hook
export { useJobs } from './useJobs';
export type { UseJobsReturn } from './useJobs';

// Matching hook
export { useMatching } from './useMatching';
export type { UseMatchingReturn } from './useMatching';

// Career Intelligence hook
export { useCareerIntelligence } from './useCareerIntelligence';
export type { UseCareerIntelligenceReturn } from './useCareerIntelligence';

// Availability hook
export { useAvailability } from './useAvailability';
export type { UseAvailabilityReturn } from './useAvailability';

// Taxonomy hook
export { useTaxonomy, useTaxonomyItem, useTaxonomyCategory, useTaxonomyLabel } from './useTaxonomy';
